import { handleWisdomStoreClick } from "core/helpers/mobileStore";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { satisfies } from "semver";
import Button from "shared/UI/Buttons/Button";
import { Modal, ModalBody, ModalFooter } from "shared/UI/Modal/Modal";

export const AppVersionModal = () => {
  const [showAppVersionModal, setShowAppVersionModal] = useState<boolean>(false);
  const [showRequiredAppVersion, setShowRequiredAppVersion] = useState<boolean>(false);

  const { isMobileApp, platform, appVersion, loading } = useMobilePlatform();

  useEffect(() => {
    const getMobileAppVersion = async () => {
      if (appVersion) {
        if (!satisfies(appVersion, process.env.REACT_APP_MIN_MOBILE_APP_VERSION!)) {
          setShowAppVersionModal(true);
          setShowRequiredAppVersion(true);
        } else if (!satisfies(appVersion, process.env.REACT_APP_SUGGESTED_MOBILE_APP_VERSION!)) {
          setShowAppVersionModal(true);
        }
      }
    };

    if (isMobileApp) {
      getMobileAppVersion();
    }
  }, [appVersion, isMobileApp]);

  const dismissAction = () => {
    if (!showRequiredAppVersion) {
      setShowAppVersionModal(false);
    }
  };

  if (loading) {
    return null;
  }

  return (
    <>
      {isMobileApp && showAppVersionModal && (
        <Modal
          title={showRequiredAppVersion ? t("appVersionModel.required.title") : t("appVersionModel.suggested.title")}
          width="xs"
          bgDismiss={!showRequiredAppVersion}
          hideDismiss
        >
          <ModalBody>
            <p>{showRequiredAppVersion ? t("appVersionModel.required.description") : t("appVersionModel.suggested.description")}</p>
          </ModalBody>
          <ModalFooter>
            <Button
              text={showRequiredAppVersion ? t("appVersionModel.required.update") : t("appVersionModel.suggested.update")}
              onClick={() => platform && handleWisdomStoreClick(platform, "app_version_modal")}
            />
            {!showRequiredAppVersion && <Button variant="text" text={t("appVersionModel.suggested.later")} onClick={dismissAction} />}
          </ModalFooter>
        </Modal>
      )}
    </>
  );
};
